<script>
import {mapActions} from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 排出事業者・事業場選択コンポーネント
 *
 */
export default {
  name: "InfiniteEmissionAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    /**
     * 事業者ID
     */
    supplierId: {
      type: Number,
      default: () => null,
    },
    supplierName: {
      type: String,
      default: () => null,
    },
    /**
     * 事業者ラベル
     */
    label: {
      type: String,
      default: "排出事業者",
    },
    /**
     * 事業者 必須
     */
    required: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    /**
     * 排出事業者 非活性化
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    md: {
      type: [Number, String],
      default: 4,
    },
    classes: {
      type: String,
      default: null,
    },
    excludeGeneral: {
      type: Boolean,
      default: false,
    },
    excludeInvisible: {
      type: Boolean,
      default: false,
    },
    onlyValidLocation: {
      type: Boolean,
      default: false,
    },
    /**
     * サーバから返す選択可否を無視するか。
     */
    uncontrolDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      searchKeyword: null,
      timerId: undefined,
      pageNumber: 0,
      suppliers: [],
      pagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
      workableName: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 排出事業者IDの変更検知
     * @param newValue 排出事業者ID
     * @param oldValue
     */
    supplierId(newValue, oldValue) {
      this.searchKeyword = null;
      this.workableId = newValue;
      if (newValue !== oldValue) {
        this.loadSupplier(this.workableId);
      }
    },
    supplierName(newValue) {
      this.workableName = newValue;
    },
    /**
     * 作業用排出事業場IDの変更検知
     */
    workableId() {
      this.returnValues();
    },
  },
  created() {
    if (this.supplierId) {
      this.workableId = this.supplierId;
      this.loadSupplier(this.workableId);
    } else {
      this.fetchSupplierMembers();
    }
  },
  methods: {
    ...mapActions("DriverMasterSearchEmissionMember", {
      fetchSuppliers: "index",
    }),
    loadSupplier(id) {
      const conditions = {
        name: null,
        target_id: id,
        without_general_form: this.excludeGeneral,
        uncontrol_disabled: this.uncontrolDisabled,
        without_invisible: this.excludeInvisible,
        only_valid_location: this.onlyValidLocation,
        page: 1,
      };

      this.fetchSuppliers({ params: conditions }).then((response) => {
        this.suppliers = response.emissions;
        this.workableName = this.suppliers[0].name;
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      });
    },
    /**
     * 排出事業者のリロード処理
     */
    reloadSuppliers() {
      this.searchKeyword = null;
      this.pageNumber = 0;
      this.suppliers = [];
      Object.assign( this.$data.pagination, this.$options.data().pagination );
      this.fetchSupplierMembers();
    },
    /**
     * 排出事業者オプション取得アクション
     * @returns {Promise<unknown>}
     */
    fetchSupplierMembers() {
      this.loading = true;
      const conditions = {
        query: this.searchKeyword,
        without_general_form: this.excludeGeneral,
        uncontrol_disabled: this.uncontrolDisabled,
        without_invisible: this.excludeInvisible,
        only_valid_location: this.onlyValidLocation,
        page: this.pageNumber,
      };
      this.fetchSuppliers({ params: conditions }).then((response) => {
        this.suppliers = this.suppliers.concat(response.emissions);
        this.pagination = response.pagination;
        this.pageNumber = response.pagination.current_page;
      })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 排出事業者 チェンジイベント
     */
    changeCallback(item) {
      this.workableId = item?.id || null;
      this.workableName = item?.name || null;
    },
    /**
     * 事業者クリア コールバック
     */
    clearCallback() {
      this.workableId = null;
      this.workableName = null;
      this.reloadSuppliers();
    },
    /**
     * 排出事業者
     * 次ページ読込
     */
    insectCallback() {
      if (this.pageNumber > 0) {
        this.pageNumber++;
        this.fetchSupplierMembers();
      }
    },
    enterKeydownCallback (value) {
      this.pageNumber = 0;
      this.searchKeyword = value;
      this.fetchSupplierMembers();

    },
    returnValues() {
      this.$emit("update:values", this.workableId, this.workableName);
    },
  },
};
</script>
<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      :value="workableId"
      :rules="{ required: required }"
      :class="{ requiredMark: required }"
      :name="label"
    >
      <InfiniteAutocomplete
        v-model="workableId"
        :classes="classes"
        :disabled="disabled"
        :errorMessages="errors"
        :label="label"
        :loading="loading"
        :members="suppliers"
        :pagination="pagination"
        :rounded="rounded"
        item-text="label"
        @change="changeCallback"
        @click:clear="clearCallback"
        @insect="insectCallback"
        @keydown:enter="enterKeydownCallback"
      >
        <template v-slot:prepend>
          <slot name="prepend" />
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner" />
        </template>
        <template v-slot:selection="{ item }">
          <slot name="selection" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:item="{ item }">
          <slot name="item" v-bind:item="item">
            {{ item.label }}
          </slot>
        </template>
        <template v-slot:append>
          <slot name="append" />
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer" />
        </template>
      </InfiniteAutocomplete>
    </validation-provider>
  </div>
</template>
